import { Injectable, inject } from '@angular/core';
import { from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { Papa } from 'ngx-papaparse';
import saveAs from 'file-saver';
import { DashboardUtils } from '../dashboard-utils';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  private http = inject(HttpClient);
  private papa = inject(Papa);


  public convertCsvToExcel(url: string) {
    return this.http.get(url, { responseType: 'blob', observe: 'response' }).pipe(
      switchMap( (res) => {
        const now = new Date();
        const fallbackContentDisposition = `attachment; filename="${now.toISOString()}.csv"`;
        const contentDispo = res.headers.get('Content-Disposition') ?? fallbackContentDisposition;
        const filename = contentDispo.slice(contentDispo.indexOf('filename="') + 10, contentDispo.indexOf('.csv')) + '.xlsx' ?? 'export-reelax-tickets.xlsx';
        return from(DashboardUtils.csvBlobToxls(this.papa, res.body as unknown as Blob, filename));
      }),
    ).subscribe({next: ({blob, fileName}) =>{
      saveAs(blob, fileName);
    }});
  }

}
